document.addEventListener('DOMContentLoaded', () => {
  const katakanaRegex = /^[ァ-ンヴー\s　]+$/;

  document.querySelectorAll('.cart-input-container').forEach((container) => {
    const bankRadio = container.querySelector('#payment-bank');
    const otherRadio = container.querySelector('#payment-other');
    const kanaInputs = container.querySelectorAll('#bank-details input');
    const bankDetails = container.querySelector('#bank-details');
    const checkoutBtn = document.querySelector('button[name="checkout"]');
    const errorMessage = container.querySelector('#error');
    const cartForm = container.closest('form');

    if (!bankRadio || !otherRadio || !bankDetails || kanaInputs.length === 0 || !cartForm) return;

    function updateFormState() {
      const selectedRadio = container.querySelector('input[name="payment_method"]:checked');
      if (!selectedRadio) {
        checkoutBtn.disabled = true;
        return;
      }
      checkoutBtn.disabled = false;

      if (selectedRadio.value === 'bank') {
        kanaInputs.forEach((input) => (input.disabled = false));
        bankDetails.style.opacity = '1';
      } else {
        kanaInputs.forEach((input) => (input.disabled = true));
        bankDetails.style.opacity = '0.5';
        errorMessage.style.display = 'none';
      }
    }

    function validateKanaInputs(e) {
      if (bankRadio.checked) {
        const lastname = container.querySelector('#lastname')?.value.trim() || '';
        const firstname = container.querySelector('#firstname')?.value.trim() || '';
        if (!katakanaRegex.test(lastname) || !katakanaRegex.test(firstname)) {
          e.preventDefault();
          errorMessage.style.display = 'block';

          for (const btn of document.querySelectorAll('.btn--loading')) {
            btn.classList.remove('btn--loading');
          }
          checkoutBtn.disabled = false;
        } else {
          errorMessage.style.display = 'none';
        }
      }
    }

    bankRadio.addEventListener('change', updateFormState);
    otherRadio.addEventListener('change', updateFormState);
    checkoutBtn.addEventListener('click', validateKanaInputs);
    cartForm.addEventListener('submit', validateKanaInputs);

    updateFormState();
  });
});
